// extracted by mini-css-extract-plugin
module.exports = {"switch":"notifications_switch__2HlP6","button":"notifications_button__36Fdn","isOn":"notifications_isOn__momc1"};